import React from 'react';

import { JiraProductDiscoveryIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <JiraProductDiscoveryIcon size="xsmall" label="" />;

export const useJiraProductDiscovery = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.JIRA_PRODUCT_DISCOVERY,
		analyticsName: Products.JIRA_PRODUCT_DISCOVERY,
		...options,
	});
